import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipeModule } from '../translate/translate.pipe.module';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ControlPanelComponent } from './control-panel.component';
import {ControlPanelRoutingModule} from './control-panel-routing.module';
import {GenericModalModule} from '../modal/generic-modal.module';
import {CreateObjectDialogModule} from '../createObjectDialog/create-object-dialog.module';
import {PeOsModule} from '../peOS/peOs.module';
import {NotepadModule} from '../notepadApp/notepad.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslatePipeModule,
        FormsModule,
        ReactiveFormsModule,
        ControlPanelRoutingModule,
        GenericModalModule,
        CreateObjectDialogModule,
        PeOsModule,
        NotepadModule
    ],
  declarations: [ControlPanelComponent],
  providers: [],
  exports: [ControlPanelComponent]
})

export class ControlPanelModule {

}
